import React, { Suspense } from 'react';

import './eventsxmedias.css';

const Event = React.lazy(() => import("../events/Events"));
const Media = React.lazy(() => import("../medias/Medias"));


export default function EventMedia(): React.JSX.Element {
    const isCompact = true;
    return (
        <div className="space-y-8">
            <Suspense fallback={<div>Chargement des évènements ...</div>}>
                <Event />
            </Suspense>
            <Suspense fallback={<div>Chargement des médias ...</div>}>
                <Media compact={isCompact} />
            </Suspense>

        </div>
    );
}
